<template>
  <div class="message">
    <h2 class="--text-center">Napište mi</h2>
    <p
      class="--text-left"
    >{{ messageDesc }}</p>
    <input type="text" name="name" placeholder="Jméno *" v-model="name" :class="{error: nameError}" />
    <div class="message__error" v-if="nameError">
      <b>Vyplňte prosím Vaše jméno</b>
    </div>
    <input
      type="text"
      name="email"
      placeholder="Email *"
      v-model="email"
      :class="{error: mailError}"
    />
    <div class="message__error" v-if="nameError">
      <b>Zadejte prosím pltnou emailovou adresu</b>
    </div>
    <textarea
      name="message"
      id
      placeholder="Zpráva *"
      v-model="message"
      :class="{error: messageError}"
    ></textarea>
    <input type="text" class="message__pot" name="phone" v-model="pot" />
    <div class="message__error" v-if="messageError">
      <b>Napište prosím vzkaz</b>
    </div>

    <span class="message__error" v-if="messageSent">
      <b>Úspěšně odesláno</b>
    </span>
    <button type="button" class="btn btn-primary" @click="sendMessage()">Odeslat</button>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      name: "",
      email: "",
      message: "",
      pot: "",
      nameError: false,
      mailError: false,
      messageError: false,
      messageSent: false,
    };
  },
  props: ['messageDesc'],
  methods: {
    validateForm: function () {
      this.nameError = this.name ? false : true;
      this.mailError = !validateEmail(this.email);
      this.messageError = this.message ? false : true;

      return !this.nameError && !this.mailError && !this.messageError;
    },
    sendMessage: function () {
      var isValid = this.validateForm();
      if (isValid) {
        axios
          .post(
            "https://script.google.com/macros/s/AKfycby_GwDt8rywwmb1gnXJHXwo57MZbueQtOUIiOIYBhJbSYmtk5jMb88Wfd3WWTL-5LId/exec",
            JSON.stringify(
              {
                name: this.name,
                email: this.email,
                message: this.message,
                pot: this.pot,
              },
              {
                headers: {
                  'Content-type':'text/plain'
                },
              }
            )
          )
          .then(() => {
            this.name = "";
            this.email = "";
            this.message = "";
            this.messageSent = true;
            setTimeout(function () {
              this.messageSent = false;
            }, 5000);
          });
      }
      return isValid;
    },
  },
};
function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
</script>
<style>
.message {
  grid-column: span 1;
  padding: 24px;
  text-align: right;
}

.message input {
  height: 64px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 24px;
  border-radius: 24px;
  border: 1px solid #c9c9c9;
  padding-left: 24px;
  color: #9c9c9c;
}

.message input:focus {
  outline: none;
  border: 1px solid #4d4d4d;
}

input.message__pot {
  display: none;
}

.message__error {
  color: #d9af91;
  text-align: left;
  margin: -12px 24px 12px 24px;
}

.message textarea {
  display: block;
  height: 250px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 24px;
  border-radius: 24px;
  border: 1px solid #c9c9c9;
  resize: vertical;
  padding: 24px 0 0 24px;
  color: #9c9c9c;
}

.message textarea:focus {
  outline: none;
  border: 1px solid #4d4d4d;
}

.message input.error,
.message textarea.error {
  border: 2px solid #d9af91;
}

@media only screen and (max-width: 800px) {
  .message {
    grid-column: span 2;
  }
}
</style>
